// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"882b5d5e","198":"e92bf17c","915":"30dab95e"}[chunkId] + ".css";
};